import React from 'react';
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { BaseTextFieldProps } from '@/types';

interface DocumentIdFieldProps extends BaseTextFieldProps {}

export default function DocumentIdField({
  value,
  error,
  setValue,
  setError,
  setChanged,
}: DocumentIdFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (!/^[a-zA-Z0-9_.-~:]*$/.test(newValue)) {
      setError(
        'Document ID can only contain letters, numbers, hyphens, and underscores',
      );
    } else if (newValue === '') {
      setError('Document ID cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Document ID'
          id='doc_id'
          aria-describedby='doc_id-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={false}
          slotProps={{ inputLabel: { shrink: value?.length > 0 } }}
        />
        {error ? (
          <FormHelperText id='doc_id-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='doc_id-helper-text'>
            Enter a unique identifier for the document (letters, numbers,
            hyphens, and underscores only)
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
